import { mountClassic } from '../render/classic/classic-app.js';
import { makeKlondikeClassicSpec } from '../variants/klondike/classic-spec.js';

const root = document.getElementById('classic-stage');
if (!root) throw new Error('missing #classic-stage');

const raw = parseInt(root.dataset.draw ?? '1', 10);
const draw: 1 | 3 = raw === 3 ? 3 : 1;
mountClassic(makeKlondikeClassicSpec({ draw }), {
  root,
  title: `Klondike · Draw ${draw}`,
});
